import { DialogueHistoryEntry, GameState } from '../../types';
import { SystemPromptBuilder } from './SystemPromptBuilder';
import { StatePromptBuilder } from './StatePromptBuilder';

/**
 * Prompt构建器类，负责构建发送给LLM的提示文本
 */
export class PromptBuilder {
  private systemPromptBuilder: SystemPromptBuilder;
  private statePromptBuilder: StatePromptBuilder;
  
  /**
   * 构造函数
   */
  constructor() {
    this.systemPromptBuilder = new SystemPromptBuilder();
    this.statePromptBuilder = new StatePromptBuilder();
  }
  
  /**
   * 构建系统提示
   * @returns 构建好的系统提示
   */
  buildSystemPrompt(): string {
    return this.systemPromptBuilder.buildSystemPrompt();
  }

  /**
   * 构建游戏状态文本
   * @param state 游戏状态
   * @returns 构建好的游戏状态文本
   */
  buildGameState(state: GameState): string {
    return this.statePromptBuilder.buildGameState(state);
  }

  /**
   * 构建对话历史文本
   * @param history 对话历史
   * @returns 构建好的对话历史文本
   */
  buildDialogueHistory(history: DialogueHistoryEntry[]): string {
    return this.statePromptBuilder.buildDialogueHistory(history);
  }

  /**
   * 构建完整的提示文本
   * @param gameState 游戏状态
   * @param playerChoice 玩家选择
   * @returns 构建好的完整提示文本
   */
  buildPrompt(gameState: GameState, playerChoice: string | null): string {
    const systemPrompt = this.buildSystemPrompt();
    const stateText = this.buildGameState(gameState);
    const historyText = this.buildDialogueHistory(gameState.dialogueHistory);
    
    let prompt = `${systemPrompt}\n\n${stateText}`;
    
    if (historyText) {
      prompt += `\n\n${historyText}`;
    }
    
    prompt += `\n\n玩家选择: ${playerChoice || '开始游戏'}`;
    
    return prompt;
  }
} 